if (!customElements.get('collection-product-card')) {
  class CollectionProductCard extends HTMLElement {
    constructor() {
      super();
      this.selectedProductId = this.getAttribute('data-related-product-id');
      this.selectors = {
        colorSwatch: '[js-color-swatch]',
        colorPreviewImage: '[data-color-item-id]',
        fieldset: 'fieldset',
        activeFieldsets: '.product-form__color-item-options.is-active, .fieldset-color-swatches',
        productForm: 'product-form',
        mainInput: 'input[name="id"]',
        colorInput: 'input[name="Color"]',
        preorderInput: 'input[js-property-preorder]',
        productOptionsWrapper: '[js-options]',
        quickAddTrigger: '.js-trigger-atc',
        mobileFormShowTrigger: '.js-mobile-form-show',
        mobileFormShowTriggerWrapper: '.js-mobile-form-show-wrapper',
      };

      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(e) {

      if (!this.currentVariant) {
        return;
      }

      this.updateVariantInput();

      this.updateVariantPreorderProperty(e);

      if (e.target.closest(this.selectors.quickAddTrigger)) {
        this.handleQuickAddTrigger(e);
      }
    }

    connectedCallback() {
      this.querySelectorAll(this.selectors.colorSwatch).forEach((swatch) => {
        swatch.addEventListener('click', this.handleSwatchChange.bind(this));

        swatch.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
            e.preventDefault();
            e.target.click();
          }
        });
      });

      this.querySelector(
        this.selectors.mobileFormShowTrigger
      )?.addEventListener('click', (e) => {
        e.target
          .closest(this.selectors.mobileFormShowTriggerWrapper)
          ?.classList.add('hidden');
        this.querySelector(this.selectors.productForm)?.classList.add(
          'is-visible'
        );
      });

      let images = null;
      if(window.innerWidth < 550) {
        images = this.querySelectorAll('img.mobile-main-image[loading="lazy"]')
      } else {
        images = this.querySelectorAll('img.desktop-main-image[loading="lazy"]')
      }
      this.handleImageLoading(images);
    }

    handleImageLoading(images) {
      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            entry.target.removeAttribute('loading')
            observer.unobserve(entry.target)
          }
        });
      }

      let options = {
        rootMargin: "400px 0px",
        threshold: 0,
      };

      const observer = new IntersectionObserver(handleIntersection, options);
      images.forEach(image => observer.observe(image));
    }

    handleQuickAddTrigger(e) {
      e.target.checked = false;
      this.querySelector('form')?.querySelector('[type="submit"]')?.click();
    }

    handleSwatchChange(e) {
      const productId = e.target.getAttribute('data-related-product-id');
      const swatches = e.target
        .closest(this.selectors.fieldset)
        ?.querySelectorAll(this.selectors.colorSwatch);
      const colorInput = this.querySelector(this.selectors.colorInput);
      const priceEl = this.querySelector('.price');
      const url = e.target.getAttribute('data-href');
      const handle = e.target.getAttribute('data-product-handle');
      const price = e.target.getAttribute('data-price');
      const compareAtPrice = e.target.getAttribute('data-compare-price');
      const colorSwatch = e.target.closest('[js-color-swatch]');

      if (compareAtPrice) {
        priceEl.classList.add('price--on-sale');
        priceEl.querySelector('s').innerHTML = compareAtPrice;
        priceEl.querySelector('.price-item--sale').innerHTML = price;
      } else {
        priceEl.classList.remove('price--on-sale');
        priceEl.querySelector('.price-item--regular').innerHTML = price;
      }

      swatches.forEach((swatch) => {
        swatch.classList.remove('is-active');
      });

      e.target.classList.add('is-active');
      this.updatesSelectedProductId(productId);

      if (colorInput) {
        colorInput.value = e.target.getAttribute('data-value');
      }

      
      this.updateMedia();

      if (url) {
        this.updateLinks(url);
      }

      if (handle) {
        this.updateHandle(handle);
      }

      // Change product title
      if (colorSwatch) {
        const productTitleSplit = colorSwatch.closest('.card').querySelector('.card__heading.h5 .full-unstyled-link');
        if (productTitleSplit) {
          const newTitle = colorSwatch.getAttribute('data-product-title');
          const newTitleOne = newTitle.split("-");
          const newTitleFirst = newTitleOne[0];
          const newTitleLast = newTitleOne[1];

          if (newTitle) {
            productTitleSplit.innerHTML = newTitleFirst + '<br role="presentation" data-uw-rm-sr=""><span class="card_product_secound_line">'+ newTitleLast +'</span>';
          }
        }
      }

      //Change Variant ID
      if (colorSwatch) {
        const variantId = colorSwatch.closest('.card').querySelector('.product-form input[type="hidden"][name="id"]');
        variantId.setAttribute('value', e.target.getAttribute('data-variant-id'));
      }
    }

    updateLinks(url) {
      if (!url) {
        return;
      }

      this.querySelectorAll('a').forEach(link => {
        link.setAttribute('href', url)
      })
    }

    updateHandle(handle) {
      if (!handle) {
        return;
      }
      this.querySelectorAll('.my-quick-product-add').forEach(productHandle => {
        productHandle.setAttribute('data-product-handle', handle);
        productHandle.setAttribute('data-product-updated-handle', handle);
      })
    }

    updatesSelectedProductId(id) {
      if (!id) {
        return;
      }

      this.selectedProductId = id;
      const options = this.querySelectorAll(
        this.selectors.productOptionsWrapper
      );

      options.forEach((option) => {
        if (option.getAttribute('data-product-id') == id) {
          option.classList.add('is-active');

          return;
        }

        option.classList.remove('is-active');
      });
    }

    updateOptions() {
      const fieldsets = Array.from(
        this.querySelectorAll(this.selectors.activeFieldsets)
      );

      this.options = fieldsets
        .sort((a, b) => {
          const positionA = Number(a.getAttribute('data-option-position'));
          const positionB = Number(b.getAttribute('data-option-position'));
          return positionA > positionB ? 1 : -1;
        })
        .map((fieldset) => {
          const radios = Array.from(fieldset.querySelectorAll('input'));

          if (radios.length == 1) {
            return radios[0].value;
          }

          return radios.find((radio) => radio.checked)?.value;
        });
    }

    updateMedia() {
      const images = [
        ...this.querySelectorAll(this.selectors.colorPreviewImage),
      ];

      if (!images.length) {
        return;
      }

      const previewImage = images.filter((image) => {
        return (
          image.getAttribute('data-color-item-id') == this.selectedProductId
        );
      });

      if (!previewImage.length) {
        return;
      }

      images.forEach((image) => image.classList.add('hidden'));
      previewImage.forEach((image => {
        image.classList.remove('hidden');
      }))
    }

  }

  customElements.define('collection-product-card', CollectionProductCard);
}
